/* imports */
import db from 'db'
import _ from 'lib/lodash'
import { storageAvailable } from 'lib/utils'

/* action types */
export const types = {
	IS_LOADING: 'TAG/IS_LOADING',
	FETCH_SUCCESS: 'TAG/FETCH_SUCCESS',
	FETCH_ERROR: 'TAG/FETCH_ERROR',
	RESET_STATE: 'TAG/RESET_STATE'
};

/* initial state */
export const initialState = {
	isLoading: false,
	error: null,
	stickerSnap: null,
	bundleSnap: null
};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case types.IS_LOADING:
			return { ...state, isLoading: true, error: null, stickerSnap: null };

		case types.FETCH_ERROR:
			return {	...state, isLoading: false, error: action.error, stickerSnap: null};

		case types.FETCH_SUCCESS:
			return { ...state, isLoading: false, error: null, stickerSnap: action.stickerSnap };

		case types.RESET_STATE:
			return initialState;

		default:
			return state;
	}
}

/* action creators */
export const actions = {
	isLoading: () => ({ type: types.IS_LOADING }),
	fetchError: error => ({ type: types.FETCH_ERROR, error }),
	fetchSuccess: (stickerSnap) => ({ type: types.FETCH_SUCCESS, stickerSnap }),
	resetState: () => ({ type: types.RESET_STATE }),
};

export const dispatchActions = {
	resetTagHandler: () => dispatch => dispatch(actions.resetState()),

	fetchStickerSnapByTag: (tag, bundleNo) => {
		return dispatch => {
			dispatch(actions.isLoading());

			db.fetchStickerSnapByTag(tag, bundleNo).then(
				stickerSnap => {
					/* GTM variable */
					if (!!_.get(stickerSnap, 'tagType') && storageAvailable()) window.sessionStorage.setItem('tagType', _.get(stickerSnap, 'tagType'));
					dispatch(actions.fetchSuccess(stickerSnap));
				},
				error => dispatch(actions.fetchError(error))
			);
		};
	}
};


// WEBPACK FOOTER //
// ./src/components/tag/tagHandlerRedux.jsx